import { type FC } from 'react'
import { getIntegrationDisplayName, type IntegrationServiceId } from '../../../../common/integrations'
import { InfoBox } from '../../../../components/InfoBox/InfoBox'
import { type AccountIntegrationConfigMappingType } from '../../../../models/Account'
import { formatMappingTypeLabels } from './utils'

interface ContactObjectLockNoticeProps {
  serviceId: IntegrationServiceId
  contactObjectLabel: string | undefined
  contactObjectLockedBy: AccountIntegrationConfigMappingType[]
}

export const ContactObjectLockNotice: FC<ContactObjectLockNoticeProps> = ({ serviceId, contactObjectLabel, contactObjectLockedBy }) => {
  if (contactObjectLockedBy.length === 0) {
    return null
  }
  const plural = contactObjectLockedBy.length > 1
  return (
    <div className='mt-2'>
      <InfoBox variant='primary'>
        The {getIntegrationDisplayName(serviceId)} contact object is fixed to {contactObjectLabel}, because the custom-built{' '}
        {formatMappingTypeLabels(contactObjectLockedBy)} mapping{plural ? 's depend' : ' depends'} on it.
      </InfoBox>
    </div>
  )
}
